import { gql } from '@apollo/client';
import {
  FieldType,
  ParticipantGroup,
  Waiver,
} from 'components/registration/v2/types';

export const QUERY = gql`
  query ShowRegistrationForm($formId: Int!, $organizationId: Int!) {
    showRegistrationForm(formId: $formId, organizationId: $organizationId) {
      id
      name
      season_id
      season {
        id
        name
        program {
          id
          name
        }
        ts_division_id
        startDate
        endDate
      }
      opened_at
      closed_at
      status
      hasSubmittedFormResults
      fields {
        id
        row
        column
        target
        required
        form_field_definition_id
        enabled
        label
        options
        multiselect
        internal
        type
        helpText
      }
      waivers {
        id
        title
        content
        filename
        originalFileName
        signatureType
        active
        hasFormWaiverResults
        externalId
      }
      participant_groups {
        id
        active
        name
        form_id
        description
        participant_fee
        from_birthdate_range
        to_birthdate_range
        gender_options
        capacity_limit
        waitlist_allowed
        hasFormResults
        roster_scope_id
        roster_scope_type
        roster_mode
      }
      formMessage {
        id
        content
        form_id
      }
      paymentAccountId
      organizationPaysProcessingFee
      allowOfflineCheckout
      partnerOfferings {
        partnerOfferingId
        enabled
      }
      ngbIntegrations {
        id
        ngbIntegrationId
        enabled
        season_start_date
        season_end_date
      }
    }
  }
`;

export type ShowRegistrationFormResponse = {
  showRegistrationForm: {
    id: number;
    name: string;
    season_id: number;
    season: {
      id: number;
      name: string;
      program: {
        id: number;
        name: string;
      };
      startDate: string;
      endDate: string;
      ts_division_id: string;
    };
    opened_at: string;
    closed_at: string;
    status: 'closed' | 'open';
    hasSubmittedFormResults: boolean;
    fields: FieldType[];
    waivers: Waiver[];
    participant_groups: ParticipantGroup[];
    partnerOfferings?: {
      enabled: boolean;
      partnerOfferingId: number;
    }[];
    formMessage: {
      id: number;
      content: string;
      form_id: number;
    };
    paymentAccountId: number;
    organizationPaysProcessingFee: boolean;
    allowOfflineCheckout: boolean;
    ngbIntegrations: {
      id: number;
      ngbIntegrationId: number;
      enabled: boolean;
      season_start_date: string;
      season_end_date: string;
    }[];
  };
};
